import IThresholdDataRepository from '../infractructure/repositories/iThresholdDataRepository';
import ThresholdDataRepository from '../infractructure/repositories/thresholdDataRepository';

class GetExternalWarehousesSaturationService {
  private readonly _jitRepository: IThresholdDataRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute() {
    return this._jitRepository.getExternalWarehousesSaturation();
  }
}

export default new GetExternalWarehousesSaturationService({
  repository: ThresholdDataRepository
});

export { GetExternalWarehousesSaturationService };
